{
  "sidebar": {
    "linkedNone": "No linked documents"
  }
}
